import { Injectable } from '@angular/core';
import { CardType } from '@bciti/types';
import { UserRecordTransformedUser } from '../user.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class UserUtilService {
    constructor(private translateService: TranslateService) {}

    public resolveApiErrorMessage(error: any, fallbackKey: string): string {
        const fallback = this.translateService.instant(fallbackKey);
        const backendErrorMessage = error?.error?.messages?.[0];

        if (backendErrorMessage) {
            const key = `pages.${backendErrorMessage}`;
            const translated = this.translateService.instant(key);

            if (translated !== key) {
                return translated;
            }
        }

        return fallback;
    }

    public getTransformedUser(user): UserRecordTransformedUser {
        let bcitiCard;
        let sportsCard;
        let libraryCard;
        let citizenCard;
        let legacyCard;
        user?.cards?.forEach((card) => {
            if (card.cardType === CardType.BCITI) {
                bcitiCard = card;
            }
            if (card.cardType === CardType.SPORTS) {
                sportsCard = card;
            }
            if (card.cardType === CardType.LIBRARY) {
                libraryCard = card;
            }
            if (card.cardType === CardType.CITIZEN) {
                citizenCard = card;
            }
            if (card.cardType === CardType.LEGACY) {
                legacyCard = card;
            }
        });

        return {
            id: user._id,
            access: user.role,
            name: `${user.firstName} ${user.lastName}`,
            email: user.email ? user.email : this.translateService.instant('common.nonavailable'),
            secEmail: user.secEmail ? user.secEmail : this.translateService.instant('common.nonavailable'),
            cardNumber: user.cardNumber,
            active: user.confirmed ? this.translateService.instant('common.yes') : this.translateService.instant('common.no'),
            emailConfirmed: user.confirmed,
            birthDate: user.birthDate,
            phone: user.phone,
            secPhone: user.secPhone,
            secPhoneExt: user.secPhonExt,
            firstName: user.firstName,
            lastName: user.lastName,
            sex: user.sex,
            bcitiCard,
            sportsCard,
            libraryCard,
            citizenCard,
            legacyCard,
            userFamily: {
                family: user.family,
            },
            preferences: user.preferences,
            picture: user.picture,
        };
    }
}
